/**
 * EU withdrawal form - two-step flow  (dev request 7)
 *
 * Progressive enhancement on purpose. Without JavaScript both fieldsets are
 * visible and the form submits in one pass, which still satisfies the directive.
 * This script only splits it into the two-step confirmation, which is the nicer
 * reading of "a two-step confirmation flow".
 */
(function () {
  'use strict';

  var FIELDS = [
    ['Name', 'contact[name]'],
    ['Email', 'contact[email]'],
    ['Order reference', 'contact[Order reference]'],
  ];

  function init(root) {
    var form = root.querySelector('.eu-withdrawal__form');
    if (!form) return;

    var stepOne = form.querySelector('[data-eu-withdrawal-step="1"]');
    var stepTwo = form.querySelector('[data-eu-withdrawal-step="2"]');
    var summary = form.querySelector('[data-eu-withdrawal-summary]');
    if (!stepOne || !stepTwo) return;

    stepTwo.hidden = true;

    var advance = document.createElement('button');
    advance.type = 'button';
    advance.className = 'eu-withdrawal__submit eu-withdrawal__continue';
    advance.textContent = 'Continue';
    stepOne.appendChild(advance);

    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'themeless eu-withdrawal__back';
    back.textContent = 'Back';
    stepTwo.appendChild(back);

    advance.addEventListener('click', function () {
      // Let the browser surface its own validation for step one only.
      var invalid = false;
      var controls = stepOne.querySelectorAll('input, textarea');

      for (var i = 0; i < controls.length; i += 1) {
        if (!controls[i].checkValidity()) {
          controls[i].reportValidity();
          invalid = true;
          break;
        }
      }
      if (invalid) return;

      if (summary) {
        var list = document.createElement('dl');

        for (var f = 0; f < FIELDS.length; f += 1) {
          var field = form.querySelector('[name="' + FIELDS[f][1] + '"]');
          var value = field && field.value ? field.value : '';
          if (!value) continue;

          var row = document.createElement('div');
          row.className = 'eu-withdrawal__summary-row';

          var term = document.createElement('dt');
          term.textContent = FIELDS[f][0];

          var definition = document.createElement('dd');
          // textContent, so a buyer's own input is never parsed as markup.
          definition.textContent = value;

          row.appendChild(term);
          row.appendChild(definition);
          list.appendChild(row);
        }

        summary.innerHTML = '';
        summary.appendChild(list);
        summary.hidden = false;
      }

      stepOne.hidden = true;
      stepTwo.hidden = false;
      stepTwo.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    back.addEventListener('click', function () {
      stepTwo.hidden = true;
      stepOne.hidden = false;
      stepOne.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-eu-withdrawal]');
    for (var i = 0; i < roots.length; i += 1) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
